<template>
	<div></div>
</template>

<script>
export default {
    name: "AddressView"
}
</script>

<style scoped>

</style>